import * as styles from "./BreadcrumbSeparator.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import { Icon } from "@frontend/components/atoms/Icon";

import type { BreadcrumbSeparatorProps } from "./Breadcrumb.types";

export function BreadcrumbSeparator({
  children,
  className,
}: BreadcrumbSeparatorProps): JSX.Element {
  return (
    <li
      role="presentation"
      aria-hidden="true"
      data-slot="breadcrumb-separator"
      className={clsx(styles.separator, className)}
    >
      {children ?? <Icon name="ChevronRight" size="sm" />}
    </li>
  );
}
